module.exports = __webpack_public_path__ + "static/media/isotop_5.0b56dd41.jpeg";